<template>
    <v-flex v-if="!isCurrentUser && !isFormerMember && hasReason()" class="reasons">
        <v-flex tag="h3">{{memberProfileConstants.REASONS_CONNECT_WITH_ME}}</v-flex>
        <v-flex class="list-items" v-for="(reason,index) in reasons.slice(0,5)" :key="index">
            {{ reason }}
        </v-flex>
    </v-flex>
</template>

<script>
import { reasonsToConnectConstants, memberProfileConstants } from "./memberProfile.constants.js";
import { mapActions, mapGetters } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant"; 
import { isNullOrUndefined } from 'util';

export default {
    name: "ReasonsToConnect",
    data: () => ({
        memberProfileConstants,
        reasonsToConnectConstants,
        reasons: [],
    }),
    props: {
        memberId: {
            type: String,
            required: true,
        },
    },
    created() {
        this.getReasonsToConnect(this.memberId);
    },
    methods: {
        ...mapActions({
            getReasonsToConnect: `memberProfile/${storeAction.getReasonsToConnect}`,
        }),
        hasReason() {
            return this.reasons.length;
        },
    },
    computed: {
            ...mapGetters({
                isFormerMember: `memberProfile/${storeGetters.isFormerMember}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                reasonsToConnect: `memberProfile/${storeGetters.reasonsToConnect}`,
                professionalExperience: `memberProfile/${storeGetters.professionalExperience}`,
            }),

        isCurrentUser() {
            if (this.memberId && this.currentUserId) {
                return this.memberId === this.currentUserId;
            }
        },
    },
    watch: {
        reasonsToConnect(val) {
            if (val) {
                    if (val.Industries && val.Industries.length > 0) {
                        let indus = null;
                        val.Industries.forEach((element) => {
                            if (indus) {
                                indus = `${indus}, ${element}`;
                            } else {
                                indus = element;
                            }
                        });
                        const statement = `${this.reasonsToConnectConstants.Industries} ${indus}`;
                        this.reasons.push(statement);                
                    }
                    if (val.Company_Size && val.Company_Size.length > 0) {
                        let companySizePrimary = null;
                        if (this.professionalExperience) {
                            this.professionalExperience.forEach((element) => {
                                if (element.isPrimary) {
                                    companySizePrimary = element.companySize;
                                }
                            });
                            if (!isNullOrUndefined(companySizePrimary)) {
                                const statement = `${this.reasonsToConnectConstants.Company_Size} ${companySizePrimary}`;
                                this.reasons.push(statement);                               
                            }
                        }
                    }
                    if (val.Business_Expertise && val.Business_Expertise.length > 0) {
                        let indus = null;
                        val.Business_Expertise.forEach((element) => {
                            if (indus) {
                                indus = `${indus}, ${element}`;
                            } else {
                                indus = element;
                            }
                        });
                        const statement = `${this.reasonsToConnectConstants.Business_Expertise} ${indus}`;
                        this.reasons.push(statement);                
                    }
                    if (val.Business_Interests && val.Business_Interests.length > 0) {
                        let indus = null;
                        val.Business_Interests.forEach((element) => {
                            if (indus) {
                                indus = `${indus}, ${element}`;
                            } else {
                                indus = element;
                            }
                        });
                        const statement = `${this.reasonsToConnectConstants.Business_Interests} ${indus}`;
                        this.reasons.push(statement);                
                    }
                    if (val.Business_Expertise_To_Interests && val.Business_Expertise_To_Interests.length > 0) {
                        let indus = null;
                        val.Business_Expertise_To_Interests.forEach((element) => {
                            if (indus) {
                                indus = `${indus}, ${element}`;
                            } else {
                                indus = element;
                            }
                        });
                        const statement = `${this.reasonsToConnectConstants.Business_Expertise_To_Interests} ${indus}`;
                        this.reasons.push(statement);                
                    }
                    if (val.Business_Interests_To_Expertise && val.Business_Interests_To_Expertise.length > 0) {
                        let indus = null;
                        val.Business_Interests_To_Expertise.forEach((element) => {
                            if (indus) {
                                indus = `${indus}, ${element}`;
                            } else {
                                indus = element;
                            }
                        });
                        const statement = `${this.reasonsToConnectConstants.Business_Interests_To_Expertise} ${indus}`;
                        this.reasons.push(statement);                
                    }
                    if (val.Communities_Name && val.Communities_Name.length > 0) {
                    let indus = null;
                    val.Communities_Name.forEach((element) => {
                        if (indus) {
                            indus = `${indus}, ${element}`;
                        } else {
                            indus = element;
                        }
                    });
                    const statement = `${this.reasonsToConnectConstants.Communities_Name} ${indus}`;
                    this.reasons.push(statement);                
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>

    .reasons {
        margin-bottom: 30px;
    }
</style>
